export enum FeatureFlags {
  COMPARE_VIEW = "designControlsComparisonView",
}
